import React from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import WorkExperience from "./components/WorkExperience";
import ResearchExperience from "./components/ResearchExperience";
import Projects from "./components/Projects";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="min-h-screen gradient-bg">
      <Navbar />
      <main>
        <Home />
        <WorkExperience />
        <ResearchExperience />
        <Projects />
        <Resume />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
